import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'eS',
  lng: 'es',
  resources: {
    es: {
      translations: require('./locales/es_MX.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['es'];

export default i18n;